import { createFormError, createValidationError, normalizeFormError, normalizeValidationError } from "./errors.js";

export const hasValue = (value)=>{
    if (value === false || value === 0) { return true; }
    if (value == null) { return false; }
    if (typeof value === "string") { return !!value.trim(); }
    if (Array.isArray(value)) { return value.length > 0; }
    return true;
};

export const toText = (raw, { max=255, trim=true, lower=false }={})=>{
    const text = String(raw ?? "");
    const cleaned = trim ? text.trim() : text;
    const sliced = cleaned.length > max ? cleaned.slice(0, max) : cleaned;
    return lower ? sliced.toLowerCase() : sliced;
};

export const toBoolean = (raw, fallback=false)=>{
    if (raw === true || raw === "true" || raw === 1 || raw === "1") { return true; }
    if (raw === false || raw === "false" || raw === 0 || raw === "0") { return false; }
    return fallback;
};

export const toDate = (raw)=>{
    if (!hasValue(raw)) { return { value:null, isEmpty:true, isValid:true }; }
    const date = raw instanceof Date ? raw : new Date(raw);
    if (!Number.isFinite(date.getTime())) { return { value:null, isEmpty:false, isValid:false }; }
    return { value:date, isEmpty:false, isValid:true };
};

export { createFormError, createValidationError, normalizeFormError, normalizeValidationError };

export const createError = createValidationError;

export const ok = value=>({ value });

export const fail = (value, codeOrError, details)=>({
    value,
    error:typeof codeOrError === "object"
        ? normalizeValidationError(codeOrError)
        : createValidationError(codeOrError, details)
});

export const addFieldError = (fieldErrors, fieldName, codeOrError, details)=>{
    fieldErrors[fieldName] = typeof codeOrError === "object"
        ? normalizeValidationError(codeOrError)
        : createValidationError(codeOrError, details);
    return fieldErrors;
};

export const addFormError = (formErrors, codeOrError, fields=[], details)=>{
    formErrors.push(typeof codeOrError === "object"
        ? normalizeFormError(codeOrError)
        : createFormError(codeOrError, fields, details)
    );
    return formErrors;
};

export const createResult = (values, fieldErrors={}, formErrors=[])=>{
    return {
        isValid: !Object.keys(fieldErrors).length && !formErrors.length,
        values,
        fieldErrors,
        formErrors
    };
};

export const runFieldMap = (input, fields, validators, context={})=>{
    const values = {};
    const fieldErrors = {};
    for (const fieldName of fields) {
        const validate = validators[fieldName];
        if (!validate) { continue; }
        const { value, error } = validate(input?.[fieldName], context, input);
        values[fieldName] = value;
        if (error) { fieldErrors[fieldName] = error; }
    }
    return { values, fieldErrors };
};

export const applyRequired = (values, fieldErrors, fields)=>{
    for (const fieldName of fields) {
        if (fieldErrors[fieldName]) { continue; }
        if (hasValue(values[fieldName])) { continue; }
        addFieldError(fieldErrors, fieldName, "required");
    }
    return fieldErrors;
};
